import { isValidIBAN } from 'ibantools';

import { AbstractControl, ValidationErrors } from '@angular/forms';

export function ibanValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  //remove all spaces before checking, otherwise iban is invalid after pasting, deleting and re-writing a number
  const ibanNumber = control.value.replaceAll(' ', '') as string;
  const validIBAN = isValidIBAN(ibanNumber);
  return validIBAN ? null : { iban: true };
}
